/**
 * Canonical Identity / API role name strings (must match backend AspNetRoles names).
 * Prefer referencing roles via {@link Constants.Roles} in UI code.
 */
export const Roles = Object.freeze({
  Admin: 'Admin',
  User: 'User',
});

/** Application constants; {@link Constants.Roles} is the single source of truth for role strings in the UI. */
export const Constants = Object.freeze({
  Roles,
});

const roleHomeRoutes = {
  [Roles.Admin]: '/app/dashboard',
  [Roles.User]: '/app/dashboard',
};

/**
 * Returns the default home route for a given role.
 * Falls back to /login if the role is unknown.
 */
export const getHomeRoute = (role) => roleHomeRoutes[role] || '/login';
